import JobsDelete from './JobsDelete'

export default JobsDelete
